import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { MissionSection } from '../components/MissionSection';
import { MetricsSection } from '../components/MetricsSection';
import { CompetenciesSection } from '../components/CompetenciesSection';
export function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <>
      <Hero data-id="element-396" />
      <MissionSection data-id="element-397" />
      <MetricsSection data-id="element-398" />
      <CompetenciesSection data-id="element-399" />
    </>;
}